import '@/styles/globals.css'
import '@shopify/polaris/build/esm/styles.css'
import '@/styles/topbar.component.css'
import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import Head from 'next/head'

import { AppProvider, Frame } from '@shopify/polaris'
import EmbeddedApp from '@/wrapper/EmbeddedApp'

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter()
  const currentPath = router.pathname
  const notEmbedPaths = new Set(['/paypal-redirect', '/paypal-prepare', '/404'])
  const polarisConfig = {
    Polaris: {
      ResourceList: {
        sortingLabel: 'Sort by',
        defaultItemSingular: 'item',
        defaultItemPlural: 'items',
        showing: 'Showing {itemsCount} {resource}',
        Item: {
          viewItem: 'View details for {itemName}',
        },
      },
      Common: {
        checkbox: 'checkbox',
      },
    },
  }

  return (
    <>
      <AppProvider i18n={polarisConfig}>
        <Frame>
          <Head>
            <title>Bulk Fulfill by Upatra</title>
            <meta name="description" content="Generated by create next app" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="icon" href="/favicon.ico" />
          </Head>

          {notEmbedPaths.has(currentPath) && <Component {...pageProps} />}

          {!notEmbedPaths.has(currentPath) && (
            <EmbeddedApp>
              <Component {...pageProps} />
            </EmbeddedApp>
          )}
        </Frame>
      </AppProvider>
    </>
  )
}
